import RichText from "@/components/RichText";
import { CoverImage } from "../components/Primitives";
import { BODY_DARK, CONTAINER, DARK_BG, EYEBROW_DARK, H1_HERO, OVERLAY_SIDE, RULE_DARK } from "../tokens";

// Héro image des pages secondaires (min-height 420px) : sur-titre, H1,
// filet, accroche — photo en fond + dégradé latéral. Les deux pages du
// handoff ne diffèrent que par l'opacité de la photo et la largeur du bloc.
function PageHero({ props = {}, opacity, maxWidth, overlay = OVERLAY_SIDE, headingClass = "" }) {
  return (
    <section className="relative min-h-[420px] flex items-center overflow-hidden" style={DARK_BG}>
      <CoverImage src={props.image_url} alt={props.alt} opacity={opacity} />
      <div className="absolute inset-0" style={{ background: overlay }} aria-hidden="true" />
      <div className={`${CONTAINER} relative`}>
      <div className="px-5 md:px-11 py-[72px]" style={{ maxWidth }}>
        <RichText as="div" className={EYEBROW_DARK} html={props.eyebrow} />
        <RichText as="h1" className={`${H1_HERO} mt-5 [text-wrap:balance] ${headingClass}`} html={props.heading} />
        <span className={`${RULE_DARK} mt-7 mb-5`} aria-hidden="true" />
        <RichText as="div" preserveParagraphs className={`${BODY_DARK} leading-[1.8]`} html={props.subheading} />
      </div>
      </div>
    </section>
  );
}

// Page « Notre savoir-faire » : machine à coudre, opacité .6, 720px.
export function SavoirHeroSection({ props }) {
  return <PageHero props={props} opacity={0.6} maxWidth={720} headingClass="text-[clamp(30px,4.4vw,50px)]" />;
}

// Page « Professionnels & contact » : bobines, opacité .5, 780px.
export function ProHeroSection({ props }) {
  return (
    <PageHero
      props={props}
      opacity={0.5}
      maxWidth={780}
      overlay="linear-gradient(90deg, rgba(10,8,6,0.88), rgba(10,8,6,0.35))"
      headingClass="text-[clamp(30px,4.2vw,48px)] leading-[1.12]"
    />
  );
}
